module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-tile-icon-03.c02c46dd.svg";